<template minapp="mpx" xlang="wxml">
  <es-layout
    custom-class="custom-class"
    useDefaultNavbar="{{false}}"
    layout="{{['header']}}"
    navbarStyle=""
    blankPageType="blank-page"
    bind:blank-retry="init"
    esMainStyle="{{ {background:'transparent'} }}"
  >
    <view slot="header">
      <es-navbar left-arrow="{{true}}">
        <change-navbar process="{{0}}" />
      </es-navbar>
    </view>
    <view class="refund-main">
      <select-station
        bind:handleClick="handleClick"
        toStation="{{toStation}}"
        startTime="{{selectDateValue}}"
        limit="{{limitDate.limitForChange}}"
        isCross="{{isCross}}"
      />
      <tips-card
        title="改签预定须知"
        sideTitle="查看详情"
        sideIcon="{{true}}"
        texts="{{tips}}"
        bind:sideClick="toPurchaseNotice"
      />
    </view>
  </es-layout>
  <es-popup
    wx:model="{{ travelCalendarVisible }}"
    position="bottom"
    closeable="{{true}}"
  >
    <es-calendar
      ref="calendar"
      type="single"
      title="选择前往日期"
      showConfirm="{{false}}"
      wx:model="{{selectDateValue}}"
      maxDate="{{limitDate.maxDate}}"
      minDate="{{limitDate.minDate}}"
      bindconfirm="onConfirm"
    >
      <!-- <view wx:if="{{limitDate.limitForChange}}" class="calendar-tip">{{calendarTip}}</view> -->
    </es-calendar>
  </es-popup>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { setStorage } from '@/utils/storage'
  import store from '@/store'
  import { formatDate, parseDate } from '@/utils/baseDate'
  import { isFastDoubleClick } from '@/utils/double-click'
  import {
    STORAGE_LIST_SEARCH_QUERY,
    STORAGE_CURRENT_SELECTED_CITY,
    STORAGE_EDIT_CITY_TYPE,
    STORATE_CONDITION_SEARCH_QUERY
  } from '@/utils/train-storage'
  import { innerRouter, pagePath } from "@/common/jump";

  createPage({
    created() {
      this.init()
    },
    data() {
      return {
        tips: [
          '每张车票只能改签一次！{{已取票、退票或改签}}的车票无法再次改签',
          '当原票价{{高于}}改签票价时，铁路局会根据原票发车的时间对票价差价额收取一定比例的{{手续费}}',
          '低价改签高价需支付改签后{{全款票价}}，原票票款将于1-15个工作日原路退回',
          '开车前不足48小时至发车后当日24时前改签发车当日后车次，铁路局会收取一定比例的改签费'
        ],
        // calendarTip: '温馨提示：铁路局规定开车前48小时内，仅可改签至票面日期当日24:00前的车次。',
        travelCalendarVisible: false,
        selectDateValue: []
      }
    },
    computed: {
      ...store.mapGetters({
        selectDate: 'travel.selectDate',
        selectCityList: 'travel.selectCityList',
        limitDate: 'change.limitDate'
      }),
      ...store.mapState({
        changeOrderInfo: 'change.changeOrderInfo'
      }),
      current_order() {
        return this.changeOrderInfo?.select_order
      },
      selectTicket() {
        return this.changeOrderInfo?.select_ticket
      },
      toStation() {
        return this.selectCityList?.[1]?.name
      },
      isCross() {
        return this.selectTicket?.every(item=> item && item.cross_border === 1)
      }
    },
    methods: {
      ...store.mapMutations({
        setTravelDate: 'travel.setTravelDate',
        changeSelectCityList: 'travel.changeSelectCityList',
      }),
      async init() {
        const {
          start_time,
          to_city_id,
          to_station_name
        } = this.current_order || {}
        this.selectDateValue = [parseDate(start_time).getTime()] // 初始出发时间
        this.changeSelectCityList({ // 初始到达站
          type: 'currentToCity',
          data: {
            id: to_city_id,
            name: to_station_name,
            subName: to_station_name,
            precise_search: '0',
          }
        })
      },
      handleClick({ detail }) {
        switch (detail.type) {
          case 'station':
              if(!this.limitDate.limitForChange && !this.isCross) {
                setStorage({ key: STORAGE_EDIT_CITY_TYPE, data: 'currentToCity' })
                innerRouter.push(pagePath().TRAINCITY)
              }
            break
          case 'date':
            this.travelCalendarVisible = true
            break
          case 'toTicket':
            this.goPage()
            break
        }
      },
      onTravelCalendarClose() {
        this.travelCalendarVisible = false
      },
      onConfirm({ detail: [selectTime] }) {
        this.setSelectTime(selectTime)
        this.onTravelCalendarClose()
      },
      setSelectTime(t) {
        t && (this.selectDateValue = [t])
        this.setTravelDate(t)
      },
      toPurchaseNotice() {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE)
      },
      goPage() {
        if (isFastDoubleClick()) {
          return
        }

        const __toStation = this.selectCityList?.[1]

        const query = {
          train_date: formatDate(this.selectDateValue[0], 'YYYY-MM-dd'),
          from_station_name: this.current_order.from_station_name,
          to_station_name: __toStation.name,
          train_type_code: '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by: 'start',
          order_rules: 'asc',
          from_precise_search: '0',
          to_precise_search: '0',
          // 1成人 2儿童 3学生 4残军
          passenger_type: this.selectTicket?.every(item=> item && item.ticket_type === '3') ? 13 : undefined,
          is_change_ticket: 1,
        }

        const current_select_city = [
          {
            id: this.current_order.from_city_id,
            name: this.current_order.from_station_name,
            precise_search: '0',
            subName: this.current_order.from_station_name
          },
          {
            id: __toStation?.id,
            name: __toStation?.name,
            precise_search: '0',
            subName: __toStation?.subName
          }
        ]
        // 车次列表查询条件
        setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: query })
        // 车次列表筛选项置空
        setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: {} })
        setStorage({
          key: STORAGE_CURRENT_SELECTED_CITY,
          data: current_select_city
        })
        const { from } = this.$mpxRoute.query
        innerRouter.push(pagePath().SEARCHLIST, { from: from })
      },
    },
    watch: {
      selectDate: {
        immediate: true,
        handler() {
          this.setSelectTime(this.selectDate)
        }
      },
    }
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  $current-main-color = #FF7C46
  .custom-class
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/9LEPzaGxxj1663308781690.png')
    background-repeat no-repeat
    background-position center center
    background-size cover
  .refund-main
    height 100%
    padding-left 12px
    padding-right 12px
    padding-bottom 134px
    overflow auto
    box-sizing border-box
  // .calendar-tip
  //   margin 4px 16px
  //   border-radius 8px
  //   background rgba(255, 244, 238, 0.5)
  //   box-sizing border-box
  //   padding 7px 12px
  //   font-family PingFangSC-Regular
  //   font-size 12px
  //   font-weight normal
  //   line-height 16px
  //   letter-spacing 0px
  //   color #FF6F2A
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'change-navbar': '@/components/change-navbar',
      'select-station': './components/select-station',
      'tips-card': '@/components/tips-card',
      'es-calendar': '@/components/calendar',
    }
  }
</script>